import { useEffect, useState } from "react";

/** A deadline remains a server rule; this clock keeps an open form honest. */
export function useDeadline(deadline: string): boolean {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const clock = window.setInterval(() => setNow(Date.now()), 1000);
    return () => window.clearInterval(clock);
  }, [deadline]);
  return Number.isFinite(Date.parse(deadline)) && Date.parse(deadline) <= now;
}

export function decisionReceipt(outcome: string): string {
  switch (outcome) {
    case "approved":
      return "Approved. The change has not been made yet; the investigation shows what happens next.";
    case "declined":
      return "Declined. The investigation continues without this request.";
    case "granted":
      return "Allowed. The investigation may read the requested contents.";
    case "applies_to_next_run":
      return "Allowed for future investigations too. This investigation's request window has closed.";
    case "dropped":
      return "The request window closed. This answer was not applied.";
    default:
      return `Answered (${outcome || "read the latest request state"}). The investigation shows the outcome.`;
  }
}

/** The time now, read again every `everyMs`: what a countdown on an open card is drawn from. */
export function useNow(everyMs = 15_000): number {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const clock = window.setInterval(() => setNow(Date.now()), everyMs);
    return () => window.clearInterval(clock);
  }, [everyMs]);
  return now;
}
